// extracted by mini-css-extract-plugin
export default {"homepage":"Homepage_homepage__cYRMw","gradient":"Homepage_gradient__eE9WI","linkToLines":"Homepage_linkToLines__ueptL"};